import {
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationPosition,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'

const BASE_CLASS = 'mt-NotificationsAdsComparator'

const NOTIFICATION_TYPES = {
  ADDED: 'added',
  MAX_ADDED: 'max-added',
  REMOVED: 'removed',
  REMOVED_ALL: 'removed-all'
}

const commonNotificationProps = {
  autoClose: moleculeNotificationAutoClose.long,
  position: moleculeNotificationPosition.relative,
  roundedCorners: moleculeNotificationBorderSizes.medium,
  variation: moleculeNotificationVariations.negative,
  showCloseButton: true,
  show: true
}

const NOTIFICATION_PROPS = {
  [NOTIFICATION_TYPES.ADDED]: {
    ...commonNotificationProps,
    type: moleculeNotificationTypes.success
  },
  [NOTIFICATION_TYPES.MAX_ADDED]: {
    ...commonNotificationProps,
    type: moleculeNotificationTypes.warning
  },
  [NOTIFICATION_TYPES.REMOVED]: {
    ...commonNotificationProps,
    type: moleculeNotificationTypes.success
  },
  [NOTIFICATION_TYPES.REMOVED_ALL]: {
    ...commonNotificationProps,
    type: moleculeNotificationTypes.success
  }
}

export {BASE_CLASS, NOTIFICATION_TYPES, NOTIFICATION_PROPS}
